export const heroSlider = () => {
	const dots = document.querySelectorAll('.dot');
    const slides = document.querySelectorAll('.slide');
    let currentSlide = 0;
    const slideDelay = 10000; // 10 seconds per slide
    let slideInterval;

    // Function to show a specific slide
    function showSlide(index) {
        slides.forEach((slide, i) => {
            slide.classList.remove('active');
            dots[i].classList.remove('active');
        });

        slides[index].classList.add('active');
        dots[index].classList.add('active');
    }

    // Function to go to the next slide
    function nextSlide() {
        currentSlide = (currentSlide + 1) % slides.length;
        showSlide(currentSlide);
    }

    // Start the automatic slider
    function startSlider() {
        slideInterval = setInterval(nextSlide, slideDelay);
    }

    // Add event listeners to dots for navigation
    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
            currentSlide = index;
            showSlide(currentSlide);
            clearInterval(slideInterval); // Restart the interval when a dot is clicked
            startSlider();
        });
    });

    // Initialize slider
    showSlide(currentSlide);
    startSlider();

}
